import { render, staticRenderFns } from "./featured-banks.vue?vue&type=template&id=60ea5433"
import script from "./featured-banks.vue?vue&type=script&lang=js"
export * from "./featured-banks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FeaturedBank: require('/var/www/components/featured/featured-bank.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
